import React from 'react';
import { Helmet } from 'react-helmet';
import './css/globals.css';
import './css/contact.css';
import './css/header.css';
import './css/footer.css';
import './css/page.css';
import Header from './sections/Header';
import Footer from './sections/Footer';
import Banner from './sections/Banner';
import Cta from './sections/Cta';
import Section3 from './sections/Section3';
import Section4 from './sections/Section4';
import Section5 from './sections/Section5';
import Section6 from './sections/Section6';
import Section7 from './sections/Section7';
import Section8 from './sections/Section8';
import Section9 from './sections/Section9';
import Section10 from './sections/Section10';
import Section11 from './sections/Section11';
import Accordion from './sections/Accordion';

const PAGE_URL = 'https://imperialpdg.com.au/services/water-leaks/';
const PAGE_TITLE = 'Expert Water Leak Detection & Repair Services | Imperial PDG Plumber Gold Coast';
const PAGE_DESCRIPTION = 'Discover top-notch water leak detection and repair services with Imperial PDG Plumber on the Gold Coast. Fast response, licensed plumbers.';

const WaterFilterInstallationPage = () => {

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Imperial PDG',
        'description': 'Dependable plumbing professionals trusted by Gold Coast residents. Rely on us to resolve all your domestic and commercial plumbing issues promptly and effectively',
        'url': 'https://imperialpdg.com.au/',
        'telephone': '1300631226',
        'address': {
          '@type': 'PostalAddress',
          'addressLocality': 'Gold Coast',
          'addressRegion': 'QLD',
          'postalCode': '4217',
          'streetAddress': 'PO Box 4916',
          'addressCountry': 'AU'
        },
        'geo': {
          '@type': 'GeoCoordinates',
          'latitude': -28.01294080513038,
          'longitude': 153.40505834857066
        },
      };

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta name="keywords" content="water leak detection gold coast, water leak repair gold coast, leak detection plumber gold coast" />
        <link rel="canonical" href={PAGE_URL} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:site_name" content="Imperial PDG" />
        <meta property="og:image" content="https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp" />
        <meta property="og:locale" content="en_AU" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:image" content="https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp" />

        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            'name': PAGE_TITLE,
            'description': PAGE_DESCRIPTION,
            'url': PAGE_URL,
            'image': {
              '@type': 'ImageObject',
              'url': 'https://imperialpdg.com.au/img/hot-water-system-installation-gold-coast-top-banner.webp',
              'width': 1200,
              'height': 630
            },
            'breadcrumb': {
              '@type': 'BreadcrumbList',
              'itemListElement': [
                { '@type': 'ListItem', 'position': 1, 'item': { '@id': 'https://imperialpdg.com.au/', 'name': 'Home' } },
                { '@type': 'ListItem', 'position': 2, 'item': { '@id': PAGE_URL, 'name': 'Water Leaks Detection' } }
              ]
            }
          })}
        </script>
      </Helmet>
      <div className='waterLeaks'>
        <Header />
        <Banner 
          backgroundImg={"/img/hot-water-system-installation-gold-coast-top-banner.webp"}
          backgroundAltText={"Plumber walking with a tool bag outside"}
          title={"<b>Water Leaks</b> <br>Gold Coast"}
          subtitle={"Swift and Reliable Leak Detection and Repair Services"}
        />
        <Cta />
        <Section9
          imgWebp={"/img/Water-Filter-Installation-Gold-Coast-second-image.webp"}
          imgJpg={"/img/Water-Filter-Installation-Gold-Coast-second-image.jpg"}
          imgAlt={"Plumber with a tool bag walking beside a hot water system"}
          title={"Expert Leak Detection and Repair Services"}
          subtitle={"Welcome to Imperial PDG"}
          desc={"<p class='desc'>Discover unparalleled expertise with Imperial PDG Plumber, your premier solution for water leaks on the Gold Coast. Our seasoned professionals utilise the latest technology and techniques to swiftly identify and rectify any leaks, ensuring your home or business is protected against water damage. With a commitment to excellence and a keen eye for detail, we guarantee a hassle-free service that not only fixes your current issues but also safeguards your property for the future. Choose Imperial PDG Plumber for a watertight service that stands the test of time.</p>"}
        />
        <Section10
          imgWebp={"/img/bundalls-gold-coast-plumbing-expert-3.webp"}
          imgJpg={"/img/bundalls-gold-coast-plumbing-expert-3.jpg"}
          imgAlt={"Plumber with a tool bag installing a hot water system"}
          title={"Why Choose Imperial PDG?"}
          subtitle={"Water Leakage Solutions"}
          desc={"<h6>Swift Detection</h6><p class='desc'>Leveraging cutting-edge technology to quickly locate leaks, saving you time and money.</p><h6>Comprehensive Solutions</h6><p class='desc'>From minor repairs to major overhauls, our services cover every aspect of leak prevention and repair.</p><h6>Exceptional Service</h6><p class='desc'>Our team of friendly, skilled professionals is dedicated to providing outstanding customer service and impeccable workmanship.</p>"} 
        />
        <Section9
          imgWebp={"/img/Water-Filter-Installation-Gold-Coast-second-image.webp"}
          imgJpg={"/img/Water-Filter-Installation-Gold-Coast-second-image.jpg"}
          imgAlt={"Plumber with a tool bag walking beside a hot water system"}
          title={"The Gold Standard in Water Leak Repairs"}
          subtitle={"The Difference"}
          desc={"<p class='desc'>At Imperial PDG Plumber, we set the gold standard for water leak detection and repair on the Gold Coast. Our expert team combines traditional craftsmanship with modern technology to deliver services that not only resolve your immediate concerns but also enhance the longevity and efficiency of your plumbing system. Embrace peace of mind with our comprehensive approach to leak detection, where every repair is executed with precision and care, ensuring lasting results.</p>"}
        />

        <Section10
          imgWebp={"/img/bundalls-gold-coast-plumbing-expert-3.webp"}
          imgJpg={"/img/bundalls-gold-coast-plumbing-expert-3.jpg"}
          imgAlt={"Plumber with a tool bag installing a hot water system"}
          title={"What Sets Us Apart?"}
          subtitle={"Commitment"}
          desc={"<h6>Innovative Techniques</h6><p class='desc'>Employing the latest in leak detection technology for accuracy and efficiency.</p><h6>Tailored Solutions</h6><p class='desc'>Understanding that each leak is unique, we provide customised repair strategies to best suit your needs.</p><h6>Customer Satisfaction</h6><p class='desc'>At the heart of our service is a commitment to ensuring your complete satisfaction, reflected in our meticulous attention to detail and superior service.</p><p class='desc'>Whether you're facing an urgent leak issue or seeking to prevent future problems, Imperial PDG Plumber is your trusted partner on the Gold Coast. With our expert team, state-of-the-art technology, and commitment to quality, we're here to provide a seamless and effective solution to water leaks. Choose excellence. Choose Imperial PDG Plumber.</p>"}  
        />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />  
        <Section8 />
        <Section7 />
        <Footer />
      </div>
    </>

  )
}

export default WaterFilterInstallationPage

